(function($) {
    // Grab src from data atribute on button
    var videoSrc;

    $('.js-modal-trigger').on('click', function(e) {
        e.preventDefault();
        videoSrc = $(this).attr('data-src');
    });

    // Autoplay video when modal opens
    $('.photo-video-modal').on('shown.bs.modal', function(e) {
        $(this).find('.modal-iframe').attr('src', videoSrc + "?autoplay=1&amp;modestbranding=1&amp;showinfo=0");
    });

    // Stop playing play video when modal closes
    $('.photo-video-modal').on('hide.bs.modal', function(e) {
        $(this).find('.modal-iframe').attr('src', '');
    });

})(jQuery);